import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalPicklistService extends DatabaseGwService {
  URL_PATH: string="/global-picklists";
}
